<div #pdf_container class="container"></div>
<div
  style="position: absolute; right: 20px; top: 20px; border-radius: 5px; background-color: whitesmoke;"
  fxLayout="column"
  fxLayoutAlign="start center">
  <div fxLayout="row" fxLayoutAlign="center center">
    <mat-icon
      [ngClass]="navIndex === 0 ? 'nav-inactive' : 'nav-active'"
      style="padding: 0px 14px 0px 0px; font-size: 40px; height: 40px;"
      fontIcon="arrow_left"
      title="Previous"
      (click)="movePrevNavigation()">
    </mat-icon>
    <span style="font-weight: bold;">
      Nav {{ navIndex + 1 }} / {{ totalNavigations }}
    </span>
    <mat-icon
      [ngClass]="navIndex === totalNavigations - 1 ? 'nav-inactive' : 'nav-active'"
      style="padding-right: 10px; font-size: 40px; height: 40px;"
      fontIcon="arrow_right"
      title="Next"
      (click)="moveNextNavigation()">
    </mat-icon>
  </div>
  <div style="border-radius: 4px;">
    <mat-slider min="0.5" max="3" step="0.1">
      <input matSliderThumb [formControl]="zoomControl">
    </mat-slider>
  </div>

</div>

